import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

import {AuthService} from '../services/auth.service';
import {environment} from "../../../../../environments/environment";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const user = this.authService.userObject;
    if (user && user.token && !request.url.includes(environment.s3)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${user.token}`
        }
      });
      const polarixToken = this.authService.polarix;
      if (polarixToken) {
        request = request.clone({
          setHeaders: {
            PolarixAuthorization: polarixToken
          }
        });
      }
      if (this.authService.isEmulating()) {
        request = request.clone({
          setHeaders: {
            'X-Emulating': 'true',
            'X-Emulating-Admin-Id': this.authService.userObject.admin?.id?.toString() ?? ''
          }
        });
      }
    }

    return next.handle(request);
  }
}
